const Apply = () => import('@/views/pay/Apply')
const ApplyDetail = () => import('@/views/pay/ApplyDetail')
const ApplyList = () => import('@/views/pay/ApplyList')
const PaymentCode = () => import('@/views/pay/PaymentCode')
const Merchants = () => import('@/views/pay/Merchants')
const Stores = () => import('@/views/pay/Stores')
const PayAudit = () => import('@/views/pay/PayAudit')
const ApplyAudit = () => import('@/views/pay/ApplyAudit')
const payGoods = () => import('@/views/pay/Goods')
const payGoodsCategory = () => import('@/views/pay/GoodsCategory')
const DeviceCategory = () => import('@/views/pay/deviceCategory')
const DeviceManage = () => import('@/views/pay/DeviceManage')
const DeviceModel = () => import('@/views/pay/DeviceModel')
export const pay = [
  {
    path: '/pay/apply',
    name: '申请店播pay',
    component: Apply,
    meta: {
      requireAuth: true,
      title: '申请店播pay'
    }
  },
  {
    path: '/pay/apply/detail',
    name: '申请店播pay详情',
    component: ApplyDetail,
    meta: {
      requireAuth: true,
      title: '申请店播pay详情'
    }
  },
  {
    path: '/pay/merchant',
    name: '申请列表',
    component: ApplyList,
    meta: {
      requireAuth: true,
      title: '申请列表'
    }
  },
  {
    path: '/pay/apply/audit',
    name: '进件审核',
    component: ApplyAudit,
    meta: {
      requireAuth: true,
      title: '进件审核'
    }
  },
  {
    path: '/pay/paymentCode',
    name: '固定收款码',
    component: PaymentCode,
    meta: {
      requireAuth: true,
      title: '固定收款码'
    }
  },
  {
    path: '/merchant',
    name: '商户列表',
    component: Merchants,
    meta: {
      requireAuth: true,
      title: '商户列表'
    }
  },
  {
    path: '/store',
    name: '门店列表',
    component: Stores,
    meta: {
      requireAuth: true,
      title: '门店列表'
    }
  },
  {
    path: '/pay/audit',
    name: '审核列表',
    component: PayAudit,
    meta: {
      requireAuth: true,
      title: '审核列表'
    }
  },
  {
    path: '/pay/goods',
    name: '商品列表',
    component: payGoods,
    meta: {
      requireAuth: true,
      title: '商品列表'
    }
  },
  {
    path: '/pay/goods/category',
    name: '商品类别列表',
    component: payGoodsCategory,
    meta: {
      requireAuth: true,
      title: '商品类别列表'
    }
  },
  {
    path: '/device/category',
    name: '设备类型',
    component: DeviceCategory,
    meta: {
      requireAuth: true,
      title: '设备类型'
    }
  },
  {
    path: '/device/model',
    name: '设备型号',
    component: DeviceModel,
    meta: {
      requireAuth: true,
      title: '设备型号'
    }
  },
  {
    path: '/device/manage',
    name: '设备管理',
    component: DeviceManage,
    meta: {
      requireAuth: true,
      title: '设备管理'
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/pay.route.js